import useRootSelector from '@app/hooks/useRootSelector';
import ToastElement from './ToastElement';
import { AnimatePresence } from 'framer-motion';
import Box from '../Box';
import { useEffect, useRef, useState } from 'react';
import { toastManagerStyles } from './styles';

const ToastManager = () => {
  const toastsList = useRootSelector(state => state.app.toastManager);
  const [isScrollable, setIsScrollable] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(
    () => () => {
      document.addEventListener('resize', () => {
        if (!containerRef.current) return;
        setIsScrollable(
          containerRef.current?.scrollHeight + 90 > window.innerHeight,
        );
      });
    },
    [],
  );
  useEffect(() => {
    if (!containerRef.current) return;
    setIsScrollable(
      containerRef.current?.scrollHeight + 90 > window.innerHeight,
    );
  }, [toastsList]);

  const list = [...toastsList].reverse();

  return (
    <Box
      ref={containerRef}
      csx={[toastManagerStyles(isScrollable), { paddingBottom: '15px' }]}>
      <AnimatePresence initial={false} mode="popLayout">
        {list.slice(0, 2).map((item, index) => {
          const isStacked = index === 1 && list.length > 2;
          return (
            <Box csx={{ position: 'relative' }} key={`toast-${item.id}`}>
              <ToastElement {...item} />
              {isStacked && (
                <>
                  <Box
                    csx={{
                      position: 'absolute',
                      bottom: -15,
                      zIndex: -1,
                      width: '100%',
                    }}
                    style={{
                      transform: 'scale(.95)',
                    }}>
                    <ToastElement {...list[2]} action={undefined} />
                  </Box>
                  {list.length > 3 && (
                    <Box
                      csx={{
                        position: 'absolute',
                        bottom: -25,
                        zIndex: -2,
                        width: '100%',
                      }}
                      style={{
                        transform: 'scale(.9)',
                      }}>
                      <ToastElement {...list[3]} action={undefined} />
                    </Box>
                  )}
                </>
              )}
            </Box>
          );
        })}
      </AnimatePresence>
    </Box>
  );
};

export default ToastManager;
